import { Component, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/core/contentful.service';
import { Entry } from 'contentful';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {
  events: Entry<any>[] = [];
  pastEvents: Entry<any>[] = [];
  constructor(
    private contentfulService: ContentfulService,
    public nav: NavbarService,
    private seo: SeoService
  ) { }

  ngOnInit() {
    this.nav.show();

    this.seo.updateTags({
      title: 'Upcoming Events & Programs',
      description: 'Join us for community gatherings, culturally enriching programs, lectures, and special exhibitions at Bayou Lacombe Museum.',
      url: '/events',
      keywords: 'events, museum events, lacombe, history, Louisiana culture, heritage festivals, lectures'
    });

    // Fetch upcoming events
    this.contentfulService.getUpcomingEvents()
      .then(events =>
        this.events = events
      );

    // Fetch recent past events (limit 3)
    this.contentfulService.getPastEvents({ limit: 3 })
      .then(events =>
        this.pastEvents = events
      );
  }

}
